/** Pequenos utilitários de apresentação (pt-BR). */

export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

export function formatRelativeTime(ts?: number): string {
  if (!ts) return "";
  const diff = Date.now() - ts;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "agora";
  if (min < 60) return `há ${min} min`;
  const hours = Math.floor(min / 60);
  if (hours < 24) return `há ${hours} h`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `há ${days} d`;
  return new Date(ts).toLocaleDateString("pt-BR", { day: "2-digit", month: "short" });
}

export function formatCost(cost?: number): string {
  if (cost === undefined || cost === null) return "—";
  return `US$ ${cost.toFixed(cost < 1 ? 4 : 2)}`;
}

export function formatTokens(t?: { input: number; output: number; reasoning?: number }): string {
  if (!t) return "—";
  const total = (t.input ?? 0) + (t.output ?? 0) + (t.reasoning ?? 0);
  return `${Intl.NumberFormat("pt-BR", { notation: "compact" }).format(total)} tokens`;
}

export function truncate(text: string, max = 80): string {
  return text.length > max ? text.slice(0, max - 1) + "…" : text;
}

export function languageFromFilename(name?: string): string {
  if (!name) return "";
  const ext = name.split(".").pop()?.toLowerCase() ?? "";
  const map: Record<string, string> = {
    ts: "typescript",
    tsx: "typescript",
    js: "javascript",
    jsx: "javascript",
    py: "python",
    rb: "ruby",
    go: "go",
    rs: "rust",
    java: "java",
    kt: "kotlin",
    c: "c",
    h: "c",
    cpp: "cpp",
    cs: "csharp",
    php: "php",
    sh: "bash",
    bash: "bash",
    zsh: "bash",
    json: "json",
    yml: "yaml",
    yaml: "yaml",
    toml: "ini",
    ini: "ini",
    css: "css",
    scss: "scss",
    html: "xml",
    xml: "xml",
    svg: "xml",
    md: "markdown",
    sql: "sql",
    dockerfile: "dockerfile",
  };
  return map[ext] ?? "";
}

export function detectLanguageFromFence(info?: string): string {
  return (info ?? "").trim().split(/\s+/)[0] ?? "";
}
